import type { Http } from '../http';
import { endpoints } from '../endpoints';
import type { RawCodesResponse, RawContractsResponse } from '../types/code';
import type { RequestOptions } from '../types/common';

export function createCodeApi(http: Http) {
  return {
    async getUseCodes(options?: RequestOptions): Promise<RawCodesResponse> {
      const res = await http.get<RawCodesResponse>(endpoints.code.uses, {
        signal: options?.signal,
      });
      return res.data;
    },

    async getExportContracts(options?: RequestOptions): Promise<RawContractsResponse> {
      const res = await http.get<RawContractsResponse>(endpoints.code.contractsExport, {
        signal: options?.signal,
      });
      return res.data;
    },

    async getSelfContracts(options?: RequestOptions): Promise<RawContractsResponse> {
      const res = await http.get<RawContractsResponse>(endpoints.code.contractsSelf, {
        signal: options?.signal,
      });
      return res.data;
    },
  };
}
